import { ComponentType, lazy } from "react";

const RELOAD_FLAG_KEY = "chunk-reload-at";
const RELOAD_LOOP_WINDOW_MS = 15000;

export const isChunkLoadError = (error: unknown): boolean => {
  const err = error as { name?: string; message?: string } | null;
  const message = err?.message || "";
  return (
    err?.name === "ChunkLoadError" ||
    /Loading (CSS )?chunk [\w-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Unexpected token '<'/.test(message)
  );
};

const readReloadFlag = (): number => {
  try {
    return Number(sessionStorage.getItem(RELOAD_FLAG_KEY)) || 0;
  } catch {
    return 0;
  }
};

const writeReloadFlag = (value: number | null) => {
  try {
    if (value === null) sessionStorage.removeItem(RELOAD_FLAG_KEY);
    else sessionStorage.setItem(RELOAD_FLAG_KEY, String(value));
  } catch {}
};

export const reloadOnceForChunkError = (): boolean => {
  if (Date.now() - readReloadFlag() < RELOAD_LOOP_WINDOW_MS) return false;
  writeReloadFlag(Date.now());
  window.location.reload();
  return true;
};

export function lazyWithRetry<T extends ComponentType<any>>(factory: () => Promise<{ default: T }>) {
  return lazy(async () => {
    try {
      const module = await factory();
      writeReloadFlag(null);
      return module;
    } catch (error) {
      if (isChunkLoadError(error) && reloadOnceForChunkError()) {
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
}
